module.exports = __webpack_public_path__ + "img/partner-4-light.0e4faac5.png";